import React from "react";
import { Checkbox, Label } from "@activecollab/components";
import { Field } from "formik";
import PropTypes from "prop-types";

const ClientFormCheckbox = ({ name, label }) => {
  return (
    <div className="tw-flex tw-items-center tw-gap-2">
      <Field
        type="checkbox"
        name={name}
      >
        {({ field, form }) => (
          <>
            <Checkbox
              {...field}
              id={name}
              onChange={(e) => {
                form.setFieldValue(field.name, e.target.checked);
              }}
            />
            <Label
              htmlFor={name}
              className="tw-mb-0 tw-cursor-pointer"
              weight="regular"
            >
              {label}
            </Label>
          </>
        )}
      </Field>
    </div>
  );
};

ClientFormCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default ClientFormCheckbox;
